
// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 } from 'uuid';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
    state: {
        krogerAuthConfig: {
            baseUri: '',
            clientId: '',
            responseType: '',
            scope: '',
            redirectUri: '',
        },
        goToCartOpen: false,
        sessionId: v4(),
    },
    actions,
    getters,
    mutations,
};

export default store;
